import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { validateCarouselData } from '../../AmexUtils';
import LayoutMenuItem from './LayoutMenuItem';
import './LayoutMenus.scss';

const LayoutMenus = ({
  awsFolderName,
  baseRequestUrl,
  content: {
    menu_config: menuConfig,
    title,
    icon_ext_link: iconLink,
  },
  tabHeading,
  Analytics,
  matchMedia,
}) => {
  if (!menuConfig || menuConfig?.length === 0) return null;

  const requiredMenusKeys = ['image', 'title', 'copy', 'cta'];
  const requiredLinkKeys = ['label_desktop', 'label_mobile', 'url'];
  // filter menu items based on required keys
  const filteredMenuConfig = validateCarouselData(menuConfig, requiredMenusKeys, requiredLinkKeys);
  const menusLength = filteredMenuConfig?.length;

  if (menusLength === 0) return null;
  const sanitizedTitle = sanitizeString(title);

  return (
    <div className="LayoutMenus">
      {title && (
        <h3
          className="LayoutMenus__heading  content-heading"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedTitle,
          }}
        />
      )}
      <div className="LayoutMenus__inner">
        <div className="LayoutMenus__content">
          <ul className="LayoutMenus__grid">
            {filteredMenuConfig.slice(0, 6).map((menuItem) => (
              <li key={menuItem.copy}>
                <LayoutMenuItem
                  awsFolderName={awsFolderName}
                  baseRequestUrl={baseRequestUrl}
                  itemConfig={menuItem}
                  iconLink={iconLink}
                  Analytics={Analytics}
                  tabHeading={tabHeading}
                  matchMedia={matchMedia}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
LayoutMenus.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  content: PropTypes.shape({
    menu_config: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    icon_ext_link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  tabHeading: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
};

export default LayoutMenus;
